const updateTickets = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'schedule') {
            const {
                teams = {}
            } = action?.data || {};

            return {
                ...state,
                ticketLink: teams?.home?.tickets
            };
        }
    }

    return state;
};

export default updateTickets;
